import { render } from "./BaseSelectorBlack.vue?vue&type=template&id=e7b45e84"
import script from "./BaseSelectorBlack.vue?vue&type=script&lang=js"
export * from "./BaseSelectorBlack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__